import { View, LinearGradient } from "@gluestack-ui/themed";
import { ProgressBarProps } from "./types";
import { LinearGradient as ExpoLinearGradient } from "expo-linear-gradient";
export const ProgressBar = ({ progress }: ProgressBarProps) => {
  const gradientColors = ["#A5D447", "#08A282"];
  return (
    <View
      width="100%"
      height="$2"
      backgroundColor="$secondary100"
      borderRadius="$full"
      overflow="hidden"
    >
      <LinearGradient
        flex={1}
        width={`${progress}%`}
        // @ts-ignore: "start" is documented and works but isn't typed for some reason
        start={[0, 0]}
        // @ts-ignore: "end" is documented and works but isn't typed for some reason
        end={[1, 0]}
        // @ts-ignore: "colors" is documented and works but isn't typed for some reason
        colors={gradientColors}
        as={ExpoLinearGradient}
      />
    </View>
  );
};
